import { put, select, takeEvery } from 'redux-saga/effects';
import { setEligibility, setLocalization } from '../../store/appSlice';
import { setForm, setHasBillingInfo, setInfo } from '../../store/billingSlice';
import { setEduStatus } from '../../store/eduSlice';
import type { CustomerInfo } from '../../types/customerInfo';
import { validateBillingField } from '../../utils/validators/validators';
import { CURRENCY_SYMBOLS } from '../data';

export function* handleCustomerInfo(info: CustomerInfo) {
  const { session } = yield select((state) => state.app);

  if (session?.Email) {
    yield put(setForm({ email: session.Email }));
  }

  if (info.eligibility) {
    yield put(setEligibility(info.eligibility));
  }

  yield put(setInfo({ code: info.code }));

  if (info.code === 'USER') {
    yield put(setEduStatus(info.eduStatus));
    yield put(setInfo(info));
    yield put(setHasBillingInfo(true));
    const { firstName, lastName, address, city, zipCode, country, currency } =
      info.billToContact;
    yield put(
      setForm({
        firstName,
        lastName,
        address,
        city,
        zip: zipCode,
        country,
        vat: info.vatId || '',
      }),
    );

    if (country && currency) {
      yield put(
        setLocalization({
          countryCode: country,
          currencyCode: currency,
          currencySymbol: CURRENCY_SYMBOLS[currency] ?? currency,
        }),
      );
    }
  }
}

export function* watchSetBillingForm() {
  yield takeEvery(setForm, validateBillingField);
}
